import { Nullable } from './../../types/common'
import BaseComponent from '../base-component/base-component'
import { checkLeftKey, checkRightKey } from '../../utils/utils'

class BeforeAfterImages extends BaseComponent {
  isMoving: boolean
  step: number

  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.button = this.querySelector('[data-before-after-images-button]')

    this.isMoving = false
    this.step = 20
  }

  connectedCallback(): void {
    this.setSeparatorPosition(Number(this.dataset.initialDragPosition))

    this.button.addEventListener('keyup', this.handleButtonKeyUp)

    this.button.addEventListener('mousedown', this.handleButtonMouseDown)
    document.addEventListener('mouseup', this.handleButtonMouseUp)
    document.addEventListener('mousemove', this.handleMouseMove)

    this.button.addEventListener('touchstart', this.handleTouchStart)
    this.addEventListener('touchmove', this.handleTouchMove)
    document.addEventListener('touchend', this.handleTouchEnd)
  }

  disconnectedCallback(): void {
    this.button.removeEventListener('keyup', this.handleButtonKeyUp)

    this.button.removeEventListener('mousedown', this.handleButtonMouseDown)
    document.removeEventListener('mouseup', this.handleButtonMouseUp)
    document.removeEventListener('mousemove', this.handleMouseMove)

    this.button.removeEventListener('touchstart', this.handleTouchStart)
    this.removeEventListener('touchmove', this.handleTouchMove)
    document.removeEventListener('touchend', this.handleTouchEnd)
  }

  handleButtonMouseDown = (event: MouseEvent): void => {
    event.preventDefault()

    this.startMove()
  }

  handleButtonMouseUp = (): void => {
    this.endMove()
  }

  handleMouseMove = (event: MouseEvent): void => {
    if (!this.isMoving) {
      return
    }

    this.moveSeparator(event.pageX)
  }

  handleButtonKeyUp = (event: KeyboardEvent): void => {
    if (!this.button) {
      return
    }

    const currentKey = event.key || event.keyCode
    const isLeftKey = checkLeftKey(currentKey)
    const isRightKey = checkRightKey(currentKey)

    if (!isLeftKey && !isRightKey) {
      return
    }

    const btnRect = this.button.getBoundingClientRect()
    const btnCenterPoint = btnRect.right - btnRect.width / 2

    const newPosition = isLeftKey
      ? btnCenterPoint - this.step
      : btnCenterPoint + this.step

    this.moveSeparator(newPosition)
  }

  handleTouchStart = (): void => {
    this.startMove()
  }

  handleTouchEnd = (): void => {
    this.endMove()
  }

  handleTouchMove = (event: TouchEvent): void => {
    if (!this.isMoving) {
      return
    }

    event.preventDefault()

    this.moveSeparator(event.targetTouches[0].clientX)
  }

  startMove(): void {
    this.isMoving = true
  }

  endMove(): void {
    this.isMoving = false
  }

  setSeparatorPosition(position: number): void {
    this.style.setProperty('--gsc-drag-position', `${position}%`)
  }

  moveSeparator(newPosition: number): void {
    const rect = this.getBoundingClientRect()

    if (newPosition <= rect.left) {
      this.setSeparatorPosition(0)
    } else if (newPosition >= rect.right) {
      this.setSeparatorPosition(100)
    } else {
      const positionPercent =
        Math.floor(((newPosition - rect.left) / this.offsetWidth) * 1000) / 10

      this.setSeparatorPosition(positionPercent)
    }
  }
}

export default BeforeAfterImages
